import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { useShallow } from "zustand/react/shallow";

import { AppLayoutState, AppLayoutStore } from "./app_layout_store_types";

const INITIAL_STATE = {
  edgeToEdge: false,
  isBackdropVisible: false,
  isNavBarRevealedOnMobile: false,
  layout: "",
  leftActionPanel: { id: "", content: null, title: "...", collapsed: true },
  mainLeft: 0,
  mainRight: 0,
  mainWidth: 320,
  rightActionPanel: { id: "", content: null, title: "...", collapsed: true },
  windowHeight: 320,
  windowWidth: 320
} satisfies AppLayoutState;

export const useAppLayoutStore = create<AppLayoutStore>()(
  immer((set) => ({
    ...INITIAL_STATE,
    actions: {
      setMainDimensions: (payload) =>
        set((state) => {
          Object.assign(state, payload);
        }),
      showNavBar: () =>
        set((state) => {
          state.isNavBarRevealedOnMobile = true;
        }),
      hideNavBar: () =>
        set((state) => {
          state.isNavBarRevealedOnMobile = false;
        }),
      setEdgeToEdge: (payload) =>
        set((state) => {
          state.edgeToEdge = payload;
        }),
      setLeftActionPanel: (payload) =>
        set((state) => {
          state.leftActionPanel = { ...state.leftActionPanel, ...payload };
        }),
      showBackdrop: () =>
        set((state) => {
          state.isBackdropVisible = true;
        }),
      hideBackdrop: () =>
        set((state) => {
          state.isBackdropVisible = false;
        }),
      setLayout: (payload) =>
        set((state) => {
          state.layout = payload;
        }),
      reset: () =>
        set((state) => {
          Object.assign(state, INITIAL_STATE);
        })
    }
  }))
);

export const useAppLayoutStoreActions = () => useAppLayoutStore(useShallow((state) => state.actions));
